if($('.id--17').length){
    $('html').on('click', '#submit-order' ,function() {
        var aid = {
            "a1": $('#billCountryId option:selected').text().trim(),
            "a2": $('#billCity').val(),
            "a3": $('#billStreet').val().replace(/\d+/g, '').replace('/', '').trim(),
            "a4": $('#billStreet').val().match(/\d+/g).join('/'),
            "a5": $('#billZip').val()
        };
        sessionStorage.setItem('aid', JSON.stringify(aid));
    })
}
if($('.id--15').length){
   
}